import React, { Component } from "react";

class Header extends Component {
  render() {
    return (
      <div id='header' style={{width:"100%",height:"40px", alignContent:"center",zIndex:"10",position:"fixed", display:'none'}}>
        
        <img 
              src='/Images/SF_logo.png'
              alt="Logo"
              style={{
                height:"100%",
                marginTop:"2%",
                marginLeft:"4%"
              }} />
       
      </div>
     
    );
  }
}

export default Header;
